import api from '@/store/api/reservation'
import * as mutationTypes from './mutation-types'
import { handleApiCall } from '@/store/utils'

// Modules
import actionsLogs from './actions-logs'

const initialState = () => ({
    reservationNumber: {}
})

export default {
    namespaced: true,
    state: initialState(),
    modules: {
        actionsLogs,
    },
    getters: {
        reservationNumber: state => state.reservationNumber
    },
    actions: {
        showReservationNumber: ({ commit, dispatch }, data) => handleApiCall({ commit, dispatch }, api.showNumber, data, mutationTypes.SET_RESERVATION_NUMBER),
        reserveNumber: ({ dispatch }, data) => handleApiCall({ dispatch }, api.reserveNumber, data),
        unReserveNumber: ({ dispatch }, data) => handleApiCall({ dispatch }, api.unReserveNumber, data),
        sellNumber: ({ dispatch }, data) => handleApiCall({ dispatch }, api.sellNumber, data),
        importNumber: ({ dispatch }, data) => handleApiCall({ dispatch }, api.importNumber, data),
        resetNumber: async ({commit}) => commit(mutationTypes.RESET_RESERVATION_NUMBER)
    },
    mutations: {
        [mutationTypes.SET_RESERVATION_NUMBER]: (state, data) => state.reservationNumber = data,
        [mutationTypes.RESET_RESERVATION_NUMBER]: (state) => Object.assign(state, initialState())
    }
}
